import { Controller } from "@hotwired/stimulus"
import { attachNavTooltips } from "../lib/nav_tooltips"

// Handles project sidebar collapse/expand (icon-only when collapsed).
// Persists state via UserSetting.project_sidebar_mode.

export default class extends Controller {
  static values = {
    expandedWidth: { type: Number, default: 200 },
    collapsedWidth: { type: Number, default: 56 },
    collapsed: { type: Boolean, default: false },
    url: String
  }

  connect() {
    this._applyState()
    // Page-name tooltip on each icon while the rail is collapsed (Larry
    // 2026-08-11) — same instant bubble as the global rail.
    this._detachTips = attachNavTooltips(this.element, ".project-nav-item")
  }

  disconnect() {
    this._detachTips?.()
  }

  toggle() {
    this.collapsedValue = !this.collapsedValue
    this._applyState()
    this._persist()
  }

  _applyState() {
    const sidebar = this.element

    if (this.collapsedValue) {
      sidebar.style.width = `${this.collapsedWidthValue}px`
      sidebar.classList.add("project-sidebar-collapsed")
    } else {
      sidebar.style.width = `${this.expandedWidthValue}px`
      sidebar.classList.remove("project-sidebar-collapsed")
    }
  }

  _persist() {
    if (!this.hasUrlValue) return

    const mode = this.collapsedValue ? "sidebar-collapsed" : "sidebar-expanded"
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.urlValue, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        "Accept": "application/json"
      },
      body: JSON.stringify({ setting: { project_sidebar_mode: mode } })
    }).catch(() => {})
  }
}
